/**
 * API 응답 상태.
 */
export enum ResponseStatus {
  /** 성공. */
  SUCCESS,
  /** 정상적으로 실패. */
  FAILURE,
}

/**
 * API 응답 래퍼 클래스.
 *
 * 응답 상태--성공/실패/서버 오류/클라이언트 오류--를 구분해서 제공한다.
 * @template Ok 성공 응답 타입.
 * @template Err 실패 응답 타입. 기본값 `unknown`.
 */
export default class APIResponse<Ok, Err = string> {
  public get Status(): ResponseStatus {
    return this.status;
  }
  /**
   * 응답 데이터
   */
  public get Data(): Ok | null {
    return this.data as Ok | null;
  }

  /**
   * 응답 데이터
   */
  public get Error(): Err {
    return this.data as Err;
  }

  /**
   * HTTP 상태 응답 코드.
   *
   */
  public get StatusCode(): number {
    return this.statusCode;
  }

  /**
   * 서버에서 전달된 에러 코드
   */
  public get ErrorCode(): string {
    return this.errorCode;
  }

  /**
   * 서버에서 전달된 에러 메시지
   */
  public get ErrorMsg(): string {
    return this.errorMsg;
  }

  /**
   * @param data 성공 응답 또는 실패 응답. 오류 상황에서는 `null`.
   * @param statusCode HTTP 상태 응답 코드.
   * @param status `ResponseStatus` 열거형,
   */
  constructor(
    data: Ok | Err | null,
    statusCode: number,
    status: ResponseStatus,
    errorCode?: string,
    errorMsg?: string,
  ) {
    this.data = data;
    this.statusCode = statusCode;
    this.status = status;
    this.errorCode = errorCode || '';
    this.errorMsg = errorMsg || '';
  }
  private readonly data: Ok | Err | null;
  private readonly status: ResponseStatus;
  private readonly statusCode: number;
  private readonly errorCode: string;
  private readonly errorMsg: string;
}
